import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Link } from 'react-router-dom';
export function CardIssuingPage() {
  const {
    t,
    setLocale,
    direction,
    locale
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: iconsRef,
    isVisible: iconsVisible
  } = useScrollReveal();
  const {
    ref: descRef,
    isVisible: descVisible
  } = useScrollReveal();
  const {
    ref: featuresRef,
    isVisible: featuresVisible
  } = useScrollReveal();
  const {
    ref: cardTypesRef,
    isVisible: cardTypesVisible
  } = useScrollReveal();
  const {
    ref: moreServicesRef,
    isVisible: moreServicesVisible
  } = useScrollReveal();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useScrollReveal();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  const services = [{
    icon: 'https://cdn.magicpatterns.com/uploads/jJJ9exZ7cF9v17fSSbKt3H/licensing.svg',
    title: t('cardIssuingPage.services.licensing')
  }, {
    icon: 'https://cdn.magicpatterns.com/uploads/guSgUKtTeYPSe9cDGdvjeF/program-launching.svg',
    title: t('cardIssuingPage.services.programLaunching')
  }, {
    icon: 'https://cdn.magicpatterns.com/uploads/4tYNcQz2FUeGRW2YC4a4Qz/card-issuing.svg',
    title: t('cardIssuingPage.services.cardIssuingProcess')
  }, {
    icon: 'https://cdn.magicpatterns.com/uploads/4psMsMsSn6v1LrGWCsP1n2/card-managmenet.svg',
    title: t('cardIssuingPage.services.cardManagement')
  }];
  const column1Features = [t('cardIssuingPage.features.replicatedData'), t('cardIssuingPage.features.flexibleReporting'), t('cardIssuingPage.features.automatedCardLoading'), t('cardIssuingPage.features.atmCashDeposits'), t('cardIssuingPage.features.advancedApiIntegration'), t('cardIssuingPage.features.customerSupport')];
  const column2Features = [t('cardIssuingPage.features.issuerCmsAccess'), t('cardIssuingPage.features.ofacScrubbing'), t('cardIssuingPage.features.pinBySms'), t('cardIssuingPage.features.dailyReconciliation'), t('cardIssuingPage.features.secureTransaction'), t('cardIssuingPage.features.fraudMonitoring')];
  const column3Features = [t('cardIssuingPage.features.instantIssuance'), t('cardIssuingPage.features.chargeBackSupport'), t('cardIssuingPage.features.continuousTraining'), t('cardIssuingPage.features.settlementAssociations'), t('cardIssuingPage.features.dayToDaySupport'), t('cardIssuingPage.features.bankingAppIntegration')];
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-532">
      <Header variant="transparent-dark" data-id="element-533" />

      <main data-id="element-534">
        {/* Wrapper for hero SVG spanning hero + next sections */}
        <div className="relative" data-id="element-535">
          {/* Decorative SVG - spans hero and next 2 sections */}
          <img src="https://cdn.magicpatterns.com/uploads/nkA8NY64niUffzUbiE5oLU/about-hero.svg" alt="" role="presentation" aria-hidden="true" className="absolute right-0 pointer-events-none z-[1]" style={{
          top: '50vh',
          height: '60%'
        }} data-id="element-536" />

          {/* 1. Hero Banner */}
          <section className="relative min-h-screen overflow-hidden" ref={heroRef} aria-label="Card Issuing Hero" data-id="element-537">
            {/* Background Image */}
            <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
            backgroundImage: "url('https://cdn.magicpatterns.com/uploads/vzrJTEHKL7YLptkCCtWyTA/Image_182.jpg')"
          }} data-id="element-538" />

            <div className="relative z-10 w-full min-h-screen flex items-center" data-id="element-539">
              <div className="container mx-auto px-6 md:px-12" data-id="element-540">
                <div className="max-w-3xl" data-id="element-541">
                  <h1 className={`text-[#061D76] font-semibold leading-[1.05] mb-10 uppercase text-[32px] md:text-[44px] lg:text-[55px] whitespace-pre-line reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-542">
                    {t('cardIssuingPage.hero.title')}
                  </h1>
                  <p className={`text-base md:text-lg text-[#061D76] mb-10 max-w-xl leading-relaxed reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-543">
                    {t('cardIssuingPage.hero.subtitle')}
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 2. Services Icons Section */}
          <section className="gradient-dark-horizontal py-16 md:py-20 text-white relative overflow-hidden z-[2]" ref={iconsRef} aria-label="Card Issuing Services" data-id="element-544">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-545">
              <div className="grid grid-cols-2 md:flex md:justify-between gap-8" data-id="element-546">
                {services.map((service, index) => <div key={index} className={`flex flex-col items-center text-center reveal-hidden ${iconsVisible ? 'animate-fade-up' : ''}`} style={{
                animationDelay: `${index * 100}ms`
              }} data-id="element-547">
                    <div className="w-12 h-12 md:w-16 md:h-16 mb-3 flex items-center justify-center" data-id="element-548">
                      <img src={service.icon} alt={service.title} className="w-full h-full object-contain" data-id="element-549" />
                    </div>
                    <h2 className="text-sm md:text-base font-medium" data-id="element-550">
                      {service.title}
                    </h2>
                  </div>)}
              </div>
            </div>
          </section>

          {/* 3. Description Section */}
          <section className="section-inner gradient-light relative overflow-hidden" ref={descRef} aria-label="Card Issuing Overview" data-id="element-551">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-552">
              <div className="max-w-5xl space-y-8" data-id="element-553">
                <p className={`text-lg md:text-xl text-[#061d76] leading-relaxed reveal-hidden ${descVisible ? 'animate-fade-up' : ''}`} data-id="element-554">
                  {t('cardIssuingPage.description.paragraph1')}
                </p>
                <p className={`text-lg md:text-xl text-[#061d76] leading-relaxed reveal-hidden ${descVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-555">
                  {t('cardIssuingPage.description.paragraph2')}
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* 4. Features Checklist Section */}
        <section className="section-inner gradient-dark text-white relative overflow-hidden" ref={featuresRef} aria-label="Card Issuing Features" data-id="element-556">
          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-557">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4 md:gap-12" data-id="element-558">
              {/* Column 1 */}
              <ul className="space-y-4" data-id="element-559">
                {column1Features.map((feature, index) => <li key={index} className={`flex items-center gap-3 reveal-hidden ${featuresVisible ? 'animate-fade-up' : ''}`} style={{
                animationDelay: `${index * 50}ms`
              }} data-id="element-560">
                    <img src="https://cdn.magicpatterns.com/uploads/5WxKtahkHA882v5hd49D4b/check.svg" alt="" className="w-5 h-5 flex-shrink-0" data-id="element-561" />
                    <span className="text-white/90" data-id="element-562">{feature}</span>
                  </li>)}
              </ul>

              {/* Column 2 */}
              <ul className="space-y-4" data-id="element-563">
                {column2Features.map((feature, index) => <li key={index} className={`flex items-center gap-3 reveal-hidden ${featuresVisible ? 'animate-fade-up' : ''}`} style={{
                animationDelay: `${(index + 6) * 50}ms`
              }} data-id="element-564">
                    <img src="https://cdn.magicpatterns.com/uploads/5WxKtahkHA882v5hd49D4b/check.svg" alt="" className="w-5 h-5 flex-shrink-0" data-id="element-565" />
                    <span className="text-white/90" data-id="element-566">{feature}</span>
                  </li>)}
              </ul>

              {/* Column 3 */}
              <ul className="space-y-4" data-id="element-567">
                {column3Features.map((feature, index) => <li key={index} className={`flex items-center gap-3 reveal-hidden ${featuresVisible ? 'animate-fade-up' : ''}`} style={{
                animationDelay: `${(index + 12) * 50}ms`
              }} data-id="element-568">
                    <img src="https://cdn.magicpatterns.com/uploads/5WxKtahkHA882v5hd49D4b/check.svg" alt="" className="w-5 h-5 flex-shrink-0" data-id="element-569" />
                    <span className="text-white/90" data-id="element-570">{feature}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* 5. Card Types Section */}
        <section className="py-32 md:py-44 bg-white relative overflow-hidden" ref={cardTypesRef} aria-label="Card Types" data-id="element-571">
          {/* Top-left decorative SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/sjKgqbQqigcz9DMA9Uxgwc/top-left-csc-offers.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 left-0 w-[300px] md:w-[500px] h-auto pointer-events-none opacity-10" data-id="element-572" />

          {/* Bottom-right decorative SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/nEUZcrXhMSjhUeG5U7oqyL/csc-offers.svg" alt="" role="presentation" aria-hidden="true" className="absolute right-0 pointer-events-none opacity-60" style={{
          top: '30%',
          width: '35%',
          maxWidth: '700px'
        }} data-id="element-573" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-574">
            <div className="flex flex-col items-center" data-id="element-575">
              <h2 className={`text-[#061D76] text-center text-xl md:text-2xl lg:text-[1.65rem] font-medium leading-relaxed max-w-3xl mb-16 md:mb-20 reveal-hidden ${cardTypesVisible ? 'animate-fade-up' : ''}`} data-id="element-576">
                {t('cardIssuingPage.cardTypes.heading')}
              </h2>

              <div className={`w-full max-w-5xl reveal-hidden ${cardTypesVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-577">
                <img src="https://cdn.magicpatterns.com/uploads/1VnefRFvHEMtwuBn6GVfTf/csc-offers.png" alt={t('cardIssuingPage.cardTypes.imageAlt')} className="w-full h-auto object-contain" data-id="element-578" />
              </div>
            </div>
          </div>
        </section>

        {/* 6. More Services Section */}
        <section className="py-32 md:py-44 text-white relative overflow-hidden gradient-dark" dir={direction} ref={moreServicesRef} aria-label="More Services" data-id="element-579">
          {/* Background Curves */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1d8bba]/30 via-transparent to-transparent" aria-hidden="true" data-id="element-580"></div>

          {/* Top-right SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/2mANLj8GZ2QSoaHCJvcbje/more-service-top.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 right-0 w-[300px] md:w-[300px] h-auto pointer-events-none opacity-10" data-id="element-581" />

          {/* Bottom-left SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/6b9oFepPZ3EmycFXG1ZrBP/4.svg" alt="" role="presentation" aria-hidden="true" className="absolute bottom-0 left-0 w-[1000px] h-auto pointer-events-none" data-id="element-582" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-583">
            <h2 className={`text-white font-bold mb-12 reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
            fontSize: '1.6rem'
          }} data-id="element-584">
              {t('cardIssuingPage.moreServices')}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-0" data-id="element-585">
              {[{
              title: t('services.atmAcquiring.title'),
              description: t('services.atmAcquiring.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jegNccbhUz8TByzbmLGE3q/atm.svg',
              href: locale === 'ar' ? '/ar/services/atm-acquiring' : '/services/atm-acquiring'
            }, {
              title: t('services.merchantAcquiring.title'),
              description: t('services.merchantAcquiring.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/aLZSCF4LuiiMZtZnqW9PRT/merchant.svg',
              href: locale === 'ar' ? '/ar/services/merchant-acquiring' : '/services/merchant-acquiring'
            }, {
              title: t('services.mobilePayments.title'),
              description: t('services.mobilePayments.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jXad5oEVGh1pDvZH3TPpsH/mobile.svg',
              href: locale === 'ar' ? '/ar/services/mobile-payments' : '/services/mobile-payments'
            }].map((service, index) => <Link key={index} to={service.href} className={`group py-10 px-6 md:px-8 border border-white/10 hover:bg-[#25B8D6] transition-colors duration-300 cursor-pointer flex flex-col items-center justify-center text-center aspect-square reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
              animationDelay: `${(index + 1) * 100}ms`
            }} data-id="element-586">
                  <img src={service.icon} alt={service.title} className="w-10 h-10 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-587" />
                  <h3 className="text-lg md:text-xl font-bold mb-3" data-id="element-588">
                    {service.title}
                  </h3>
                  <p className="text-white leading-relaxed text-sm" data-id="element-589">
                    {service.description}
                  </p>
                </Link>)}
            </div>
          </div>
        </section>

        {/* 7. Join Our Bold Thinkers CTA */}
        <section className="relative py-24 text-white overflow-hidden" dir={direction} ref={ctaRef} aria-label="Call to Action" data-id="element-590">
          {/* Background Image */}
          <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
          backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')"
        }} data-id="element-591"></div>

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-592">
            <div data-id="element-593">
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 whitespace-pre-line reveal-hidden ${ctaVisible ? 'animate-fade-left' : ''}`} data-id="element-594">
                {t('aboutPage.cta.heading')}
              </h2>
              <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${ctaVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-595">
                {t('aboutPage.cta.description')}
              </p>
              <button className={`btn-primary reveal-hidden ${ctaVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-596">
                {t('aboutPage.cta.button')}
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-597" />
    </div>;
}